import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class ProlongContractCommand extends BasicCommand<ProlongContractCommand> {
    readonly virkeskopskontraktSigneringId: number;
    readonly days: number;

    static readonly $type = "ProlongContractCommand";

    static readonly $groupKey = "KontraktUtskrift";

    get primaryKey(): IPrimaryKey<ProlongContractCommand> {
        return {
            virkeskopskontraktSigneringId: this.virkeskopskontraktSigneringId
        };
    }

    constructor(virkeskopskontraktSigneringId: number, days: number) {
        super(ProlongContractCommand.$type, ProlongContractCommand.$groupKey, CommandType.Replace);
        this.virkeskopskontraktSigneringId = virkeskopskontraktSigneringId;
        this.days = days;
    }
}
